import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import classNames from 'classnames';
import './InputField.scss';

export type InputSize = 'medium' | 'large';
export type InputType = 'text' | 'email' | 'password';

export type InputProps = {
  id: string;
  name: string;
  label?: string;
  type?: InputType;
  size?: InputSize;
  className?: string;
  value?: string;
  readonly?: boolean;
  limit?: number;
  hasError?: boolean;
} & Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'size' | 'ref'>;

const sizeMap: { [key in InputSize]: string } = {
  medium: 'p-3 text-base',
  large: 'p-4 text-base',
};

const InputField = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      id,
      name,
      label,
      type = 'text',
      size = 'medium',
      className = '',
      placeholder,
      value,
      readonly,
      limit,
      hasError,
      ...props
    },
    ref,
  ) => {
    return (
      <div className="inputField-wrap">
        <input
          id={id}
          ref={ref}
          name={name}
          type={type}
          aria-label={label}
          placeholder={placeholder}
          value={value}
          className={classNames([sizeMap[size], className, { 'error-border': hasError }])} // Add hasError class conditionally
          readOnly={readonly}
          maxLength={limit}
          autoComplete="off"
          {...props}
        />
      </div>
    );
  },
);

InputField.displayName = 'InputField';

export default InputField;
